import React from 'react';

import I18n from '@interlayer/js/components/common/I18n';

import { useTranslations } from '@core/js/hooks/i18n';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TBlockInfoProps } from './types';

import style from './BlockInfo.scss';

export const BlockInfo: React.FC<TBlockInfoProps> = ({ t: tCustom, tKey, isTopLine, className }) => {
    const tDefault = useTranslations('playtech.mobile.system.registration.');
    const t = tCustom || tDefault;

    return (
        <I18n
            t={t}
            tKey={tKey}
            className={clsx(style.container, className, { [style.isTopLine]: isTopLine })}
        />
    );
};
